export default __webpack_public_path__ + "static/media/dribbble.191a1b20.svg";